"use strict";

/**
 * @module Services.TopicUpdate
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.write = void 0;
/**
 * Write a {@link Unconstrained} update constraint to the stream
 */
function write() {
  // no-op, write nothing
}
exports.write = write;